<template>
  <div class="category mr-3 float-left" :class="{selected}" @click="select">
    <span class="category-code" v-if="id">
      SE{{ id }}
    </span>
    <small class="category-name">
      {{ name }}
    </small>
  </div>
</template>

<script>
  export default {
    name: "StatPriceCategory",
    props: {
      name: String,
      id: Number,
      value: Number
    },
    computed: {
      selected() {
        return this.id === this.value
      }
    },
    methods: {
      select(){
        this.$emit('input', this.id)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Dashboard/Statistics/Market/Prices/Period/Category.vue